import { type FromUrlSearchParams } from "~/features/search/utils/historyManipulation";
import { BreadcrumbType } from "~/utils/models";

/**
 * Drops facet breadcrumbs whose facet code is not in the current user's valid
 * facet-suffix list. Tech-value breadcrumbs are always preserved.
 *
 * @param validSearchSuffixes comma-delimited suffix string sourced from the
 *   {@code /search/context} OCC resource. Membership is checked via
 *   {@code String.prototype.includes} (substring match) to preserve the historical
 *   contract; an empty string filters out every non-tech-value breadcrumb.
 */
export function filterUnavailableParams(
  params: FromUrlSearchParams,
  validSearchSuffixes: string,
  zoovuEnabled = false,
): FromUrlSearchParams {
  if (zoovuEnabled) {
    return params;
  }
  return {
    ...params,
    breadcrumbs: params.breadcrumbs.filter((bc) => {
      if (bc.type === BreadcrumbType.TECH_VALUE) {
        return true;
      }
      return validSearchSuffixes.includes(bc.facetCode);
    }),
  };
}
